<!-- 403 full-screen error -->
<div
    class="tw-min-h-screen tw-bg-gradient-to-br tw-from-[#4f0088] tw-to-[#000000] tw-relative tw-overflow-hidden tw-flex">

    <!-- Large faded background number -->
    <h1 aria-hidden="true"
        class="tw-text-[45vw] tw-text-center  tw-fixed tw-w-full tw-z-10 tw-text-white/15 tw-top-1/2 tw--translate-y-1/2 tw-font-montserrat tw-tracking-tight">
        403
    </h1>

    <!-- Error text content -->
    <div
        class="tw-z-30 tw-w-[70vw] tw-relative tw-mx-auto tw-shadow-[0_0_150px_-20px_rgba(0,0,0,0.5)] tw-m-auto">
        @for (line of errorContent; track $index) {
        <p class="tw-font-share-tech-mono tw-text-[#f5f5f5] tw-mb-5 tw-text-[17px] tw-leading-snug" [innerHTML]="line">
        </p>
        }
    </div>
</div>